export default "__VITE_ASSET__C3kUCGQ7__"